<swiper-container data-swiper-autoplay="5000" autoplay="true" navigation="false" pagination="true" [autoHeight]="true"
  [slidesPerView]="slidesPerView" style="--swiper-pagination-bottom: 0px;">
  <swiper-slide *ngFor="let item of items">
    <!-- <ion-card class="transparent item-folder" style="margin-top: 0 !important;" button
      > -->
    <!-- <ion-card-content style="padding: 0 !important;"> -->
    <div class="margin-horizontal">
      <a [routerLink]="item?.routing?.route">
        <div class="width-70 ">

          <img class="ctm-modern-img" [src]="item?.image" [alt]="item?.title" />
          <!-- <div class="ctm-modern-overlay">
              <h2 class="ion-text-center">{{ item?.title }}</h2>
            </div> -->

        </div>
        <!-- </ion-card-content> -->
        <div class="blue">
          <p>{{ item?.title }}</p>
        </div>
      </a>
    </div>
    <!-- <ion-card-header color="primary">
        <ion-card-title class="ion-text-center">
          {{ item?.title }}
        </ion-card-title>
      </ion-card-header> -->
    <!-- </ion-card> -->
  </swiper-slide>
</swiper-container>